import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { cn } from './Kit';

const { FiCopy, FiCheck } = FiIcons;

export default function CopyButton({ text, className, title }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // fallback
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }
  };

  return (
    <button
      onClick={handleCopy}
      title={title || 'Copy'}
      className={cn(
        'inline-flex items-center justify-center w-5 h-5 rounded transition-colors flex-shrink-0',
        copied
          ? 'text-green-500'
          : 'text-gray-300 hover:text-gray-500',
        className
      )}
    >
      <SafeIcon
        icon={copied ? FiCheck : FiCopy}
        className="w-3 h-3"
      />
    </button>
  );
}